module.exports = __webpack_public_path__ + "static/img/solution-bg.5669ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-bg.png
// module id = tNQI
// module chunks = 0